/* eslint-disable react/no-array-index-key */
import React from "react";
import { Provider } from "react-redux";
import "./productCarousel.scss";
import { Icon, Popover } from "@clarkinc/zest-design-system";
import Store from "~/common/Store";
import CarouselMember from "./Carousel/CarouselMember";
import { CarouselItem } from "./Carousel/CarouselItem";
import RequestQuoteSlide from "./Carousel/Slides/RequestQuoteSlide";
const worksWithPopoverId = "works-with_popover-id";
interface YouMayAlsoNeedCarouselProps {
  carouselItems: CarouselItem[];
  youMayAlsoNeedUrl?: string;
}
const YouMayAlsoNeedCarousel = ({
  carouselItems,
  youMayAlsoNeedUrl
}: YouMayAlsoNeedCarouselProps) => {
  const hasActiveSale = carouselItems.some(item => item.displaySalePrice);
  return <Provider store={Store} data-sentry-element="Provider" data-sentry-component="YouMayAlsoNeedCarousel" data-sentry-source-file="YouMayAlsoNeedCarousel.tsx">
      <div className="carousel-wrap order-[-2] lt:order-none float-left clear-left w-full xs:mb-0">
        <div className="clearfix bg-white border-gray-200 border-solid border-0 border-t p-3 xs:bg-transparent xs:border-t-0 xs:px-0 lt:bg-white lt:border lt:border-t-0 lt:border-b-0 lt:hidden lt:px-3">
          <div className="carousel-wrap__header flex items-center justify-between">
            <h2 className="flex items-center mb-0 text-lg leading-5">
              Works With
              <Popover data-sentry-element="Popover" data-sentry-source-file="YouMayAlsoNeedCarousel.tsx">
                <Popover.Trigger contentId={worksWithPopoverId} className="flex ml-1" data-sentry-element="unknown" data-sentry-source-file="YouMayAlsoNeedCarousel.tsx">
                  <Icon name="ri-question-fill" aria-label="more information" size="small" className="fill-green-500" data-sentry-element="Icon" data-sentry-source-file="YouMayAlsoNeedCarousel.tsx" />
                </Popover.Trigger>
                <Popover.Content id={worksWithPopoverId} placement="right" data-sentry-element="unknown" data-sentry-source-file="YouMayAlsoNeedCarousel.tsx">
                  &quot;Works With&quot; items are guaranteed to work with the
                  item you are viewing, such as lids that will fit a cup or
                  casters that will fit a piece of equipment. If an item is not
                  listed in this section, we do not guarantee that it will work
                  with the product you are viewing and do not recommend that you
                  purchase them for use together.
                </Popover.Content>
              </Popover>
            </h2>
            {youMayAlsoNeedUrl && <a className="font-semibold text-xs" href={youMayAlsoNeedUrl}>
                View All Items
              </a>}
          </div>
        </div>
        <div data-component="companion-items-carousel" id="you-may-also-need" className="carousel-wrap" data-feature-name="YMAN" gtm-carousel-name="Works With" suppressHydrationWarning>
          <div id="other-products" className=" carousel-box" data-component="carousel">
            <div className="ag-carousel-nav">
              <button type="button" className="ag-car-prev" data-control="prev">
                <span className="sr-only">show previous carousel items</span>
              </button>
            </div>
            <div id="youMayAlsoNeed" className="ag-carousel-frame box lt:rounded-t-none" data-testid="you-may-also-need">
              <ul className="ag-carousel ag-mini" data-slide-width="220">
                {carouselItems.map((item, index) => item.isRequestQuoteEnabled ? <li className="ag-item">
                      <RequestQuoteSlide item={item} />
                    </li> : <CarouselMember item={item} showAddToCart key={index} addToCartFormId={`relatedproduct_companion_${index}`} activeSalePricingClassNames={hasActiveSale ? "h-[37px]" : "h-[22px]"} />)}
              </ul>
            </div>
            <div className="ag-carousel-nav">
              <button type="button" className="ag-car-next" data-control="next">
                <span className="sr-only">show more carousel items</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Provider>;
};
export default YouMayAlsoNeedCarousel;